import { render, staticRenderFns } from "./TargetForRM.vue?vue&type=template&id=6a4fb3b0"
import script from "./TargetForRM.vue?vue&type=script&lang=js"
export * from "./TargetForRM.vue?vue&type=script&lang=js"
import style0 from "./TargetForRM.vue?vue&type=style&index=0&id=6a4fb3b0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports